import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { ALIGNMENTS_DATA } from "../../../../Data/UiKit/Grid";
import { HorizontalAlignment, HorizontalAlignmentClass, HorizontalAlignmentValueClass } from "../../../../Constant";
import { StaticHorizontalAlignment } from "./StaticHorizontalAlignment";
import { DynamicHorizontalAlignment } from "./DynamicHorizontalAlignment";
import GridCommonCardFooter from "../Common/GridCommonCardFooter";

const HorizontalAlignmentCart = () => {
  return (
    <Col sm="12">
      <Card>
        <CommonCardHeader title={HorizontalAlignment} span={ALIGNMENTS_DATA} />
        <CardBody className="grid-showcase grid-align">
          <StaticHorizontalAlignment />
          <DynamicHorizontalAlignment />
        </CardBody>
        <GridCommonCardFooter className={HorizontalAlignmentClass} valueClass={HorizontalAlignmentValueClass} />
      </Card>
    </Col>
  );
};

export default HorizontalAlignmentCart;
